"use strict";

var _interopRequireDefault = require("/opt/jenkins/workspace/sit-app-client/node_modules/@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preview = _interopRequireDefault(require("./preview.vue"));

var $vm = null;
var _default = {
  install: function install(Vue) {
    var Preview = Vue.extend(_preview.default);

    if (!$vm) {
      $vm = new Preview({
        el: document.createElement('div')
      });
      document.body.appendChild($vm.$el);
    }

    var preview = {
      open: function open(index, list, params) {
        $vm.open(index, list, params);
      },
      close: function close() {
        $vm.close();
      }
    };
    Vue.$preview = preview;
    Vue.mixin({
      created: function created() {
        this.$preview = Vue.$preview;
      }
    });
  }
};
exports.default = _default;